<template>
  <v-list three-line>
    <v-divider></v-divider>
    <template v-for="(user, i) in items">
      <list-user-item 
        :key="i" 
        :item="user"
        icon="fas fa-user-circle"
      ></list-user-item>
      <v-divider :key="i + 'd'"></v-divider>
    </template>
  </v-list>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ListUserItem: () => import('@/components/providers/panel/ListaUsuarioItem')
  }
}
</script>
<style scoped>
.listado {
  max-height: 150px;
  overflow-y: scroll;
}
/* width */
::-webkit-scrollbar {
    width: 9px;
    height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #000; 
    border-radius: 15px; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: rgb(15, 105, 189); 
    border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: rgb(209, 209, 209); 
}
</style>